import React, { Component } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import $ from 'jquery'
import SignaturePad from 'signature_pad'
import Icon from "../icon/icon.component.jsx"
import ActionButton from '../button/actionbutton.component.jsx'


class SignaturePadModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            error: "",
            loading: false,
            disabled: true,
            modalId: this.props.modalId || 'signature-modal',
            canvasId: this.props.canvasId || 'signature-canvas',
            btnStyle: this.props.btnStyle || {},
            signature: '',
        }
        this.signaturePad = null
        this.handleCaptureSignature = this.handleCaptureSignature.bind(this)
        this.closeModal = this.closeModal.bind(this)
        // this.resizeCanvas = this.resizeCanvas.bind(this)
        this.temporaryCanvas = null
        this.temporaryCanvasContext = null
    }

    handleCaptureSignature(event) {
        event.preventDefault()
        this.setState({ loading: true })
        let error = this.props.onConfirm(this.state.signature)
        if (!error) {
            this.closeModal(event, true)
            this.setState({ loading: false })
        } else {
            this.setState({
                error: error,
                loading: false
            })
        }
    }

    componentDidMount() {
        const canvas = document.getElementById(this.state.canvasId)
        this.signaturePad = new SignaturePad(canvas)

        this.temporaryCanvas = document.createElement('canvas')
        this.temporaryCanvasContext = this.temporaryCanvas.getContext("2d")

        this.signaturePad.onEnd = (e) => {
            let canvas = document.getElementById(this.state.canvasId)

            this.temporaryCanvas.width = canvas.offsetWidth
            this.temporaryCanvas.height = canvas.offsetHeight
            this.temporaryCanvasContext.drawImage(canvas, 0, 0)

            const ratio = Math.max(window.devicePixelRatio || 1, 1)
            canvas.width = canvas.offsetWidth * ratio
            canvas.height = canvas.offsetHeight * ratio
            canvas.getContext("2d").scale(ratio, ratio)

            this.setState({
                disabled: false,
                signature: this.signaturePad.toDataURL("image/svg+xml"),
            }, () => {
                canvas.width = this.temporaryCanvas.width
                canvas.height = this.temporaryCanvas.height - 1
                canvas.getContext("2d").drawImage(this.temporaryCanvas, 0, 0)
            })
        }
        // window.addEventListener("resize", this.resizeCanvas);
        // this.resizeCanvas();
        $('#' + this.state.modalId).modal('show')
    }

    closeModal(event, updated) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(updated)
        }
    }

    render() {

        return (
            <div>
                <div className="modal"
                    id={this.state.modalId}
                    role="dialog"
                    aria-labelledby={this.state.modalId + "Label"}
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-signature mt-sm-0 mt-xs-2" role="document">
                        <div className="modal-content">
                            <div className="modal-header d-sm-none d-md-block">
                                <div className="modal-title h5" id={this.modalId + "Label"}>
                                    <FormattedMessage
                                        id="common.signature.modal.title"
                                        defaultMessage="Signature"
                                    />
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 text-center d-none d-sm-block">
                                            <canvas className="border-bottom border-dark d-inline"
                                                width={600}
                                                height={250}
                                                id={this.state.canvasId} />
                                        </div>
                                        <div className="col-12 text-center d-block d-sm-none py-3">
                                            <p>
                                                <Icon className={'mr-2'} value={"mobile-alt"} style={{ fontSize: '80px' }} />
                                            </p>
                                            <p>
                                                <FormattedMessage
                                                    id="common.signature.modal.rotate_your_phone_message"
                                                    defaultMessage="Rotate your phone to sign"
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {this.state.error}
                                <button type="button" className="btn btn-secondary" onClick={(e) => this.closeModal(e, false)}>
                                    <FormattedMessage
                                        id="common.signature.modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <ActionButton disabled={this.state.disabled} className="btn btn-primary" onClick={this.handleCaptureSignature} isLoading={this.state.loading} style={this.state.btnStyle} >

                                    <FormattedMessage
                                        id="proposal.signature.confirm_btn"
                                        defaultMessage="Confirm"
                                    />
                                </ActionButton>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(SignaturePadModal)





// WEBPACK FOOTER //
// ./src/common/signature/modal.component.jsx